import React from 'react';
import styled from 'styled-components';
import Proptypes from 'prop-types';
import { FONTS } from 'styles/theme/fonts';
import { COLORS } from 'styles/theme/colors';

export const ContactUsButton = ({ handleClick }) => {
  return <ContactUsButton.Button onClick={handleClick}>contact us</ContactUsButton.Button>;
};

ContactUsButton.Button = styled.button`
  color: ${COLORS.primaryContactButtonText};
  background: none;
  border: none;
  font-size: 14px;
  line-height: 19px;
  font-weight: 500;
  font-family: ${FONTS.default};
  margin-top: 32px;
  display: inline-block;
  padding: 0px 0px 3px 0px;
  border-bottom: 1px solid ${COLORS.primaryContactButtonBorder};
  text-transform: capitalize;
  cursor: pointer;

  &:focus {
    outline: none;
  }
`;

ContactUsButton.propTypes = {
  handleClick: Proptypes.func,
};

export default ContactUsButton;
